<script>
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();
    export let disabled = false;

    function open (e) {
        if(!disabled && e.target.tagName != "BUTTON" && e.target.tagName != "LABEL") {
            dispatch("open");
        }
    }
</script>

<div class="item" on:click={open} class:disabled>
    <slot></slot>
</div>

<style>
    .item {
        position: relative;
        background-color: #F5F2EF;
        color: #333;
        border-radius: 0.5rem;
        margin-bottom: 1rem;
        padding: 1rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        transition: border-radius 150ms cubic-bezier(0.3, 0.1, 0.25, 1.4);
        text-decoration: none;
    }
    
    .item:not(.disabled):hover {
        border-radius: 20px;
        background-color: #ebe6e2;
        cursor: pointer;
    }
</style>